// extracted by mini-css-extract-plugin
export default {"warningIcon":"BrokenLimitWarningIcon_warningIcon__A9rlU","tooltip":"BrokenLimitWarningIcon_tooltip__PM+e8"};